import {
  IDeleteSession,
  IReadSession,
  IReadSessionFailed,
  IReadSessionSuccess,
  ISetSession,
  SessionActionTypes,
} from "./sessionTypes";

export const setSession = (signUp?: boolean): ISetSession => {
  return {
    type: SessionActionTypes.SET_SESSION,
    signUp: signUp,
  };
};

export const readSession = (): IReadSession => {
  return {
    type: SessionActionTypes.READ_SESSION,
  };
};

export const readSessionSucess = (tokenData: any): IReadSessionSuccess => {
  return {
    type: SessionActionTypes.READ_SESSION_SUCCESS,
    tokenExpiration: tokenData.exp,
    currentTenant: tokenData?.permissions?.tenant,
    scopesDetected: tokenData?.permissions?.scopes,
    role: tokenData?.permissions?.role,
    tenant: tokenData?.permissions.tenant,
  };
};

export const readSessionFailed = (error: string): IReadSessionFailed => {
  return {
    type: SessionActionTypes.READ_SESSION_FAILED,
    error: error,
  };
};

export const deleteSession = (): IDeleteSession => {
  return {
    type: SessionActionTypes.DELETE_SESSION,
  };
};
